module.exports = __webpack_public_path__ + "img/fotos_pic_mobile_de.5a96da96.jpg";